const API_BASE = process.env.REACT_APP_API_URL || '';

async function adminRequest(method, path, body = null) {
  const url = `${API_BASE}${path}`;
  const headers = { 'Content-Type': 'application/json' };

  const token = localStorage.getItem('nordic_auth_token');
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const options = { method, headers };
  if (body) {
    options.body = JSON.stringify(body);
  }

  const response = await fetch(url, options);

  let data;
  try {
    data = await response.json();
  } catch {
    const error = new Error(`Request failed: ${response.status}`);
    error.status = response.status;
    throw error;
  }

  if (!response.ok) {
    const error = new Error(data.error || `Request failed: ${response.status}`);
    error.status = response.status;
    throw error;
  }

  return data;
}

export async function getBookers() {
  return adminRequest('GET', '/api/admin/bookers');
}

export async function addBooker({ name, email, isAdmin }) {
  return adminRequest('POST', '/api/admin/bookers', { name, email, isAdmin });
}

export async function updateBooker(id, { name, email }) {
  return adminRequest('PUT', `/api/admin/bookers/${id}`, { name, email });
}

export async function deleteBooker(id) {
  return adminRequest('DELETE', `/api/admin/bookers/${id}`);
}
